import { ajax } from 'rxjs/ajax'

import history from '../history'

const BRANDING = '?branding='
const WALLET_ADDRES = '?walletAddress='
const getBrandDataUrl = symbol => `https://tokens.qiibee.com/${symbol}/settings.json`

class BrandingService {

  isBranding() {
    const { search } = history.location
    return search.indexOf(BRANDING) > -1
  }

  getSymbol() {
    const { search } = history.location
    if (this.isBranding()) {
      return search.split(BRANDING)[1]
    }

    return ''
  }

  redirectToBrand(url, address) {    
    window.location.replace(url + WALLET_ADDRES + address)
  }

  getBrandData$(symbol) {
    return ajax.get(getBrandDataUrl(symbol.toLowerCase()))
  }
}

const brandingService = new BrandingService()

export default brandingService



// WEBPACK FOOTER //
// ./src/services/branding.js